<template>
  <div
    v-show="potltData !== null"
    :class="[classes, {'wide' : potltData.length > 10}]"
  >
    <div class="inner">

      <!-- 이벤트 메뉴 리스트 -->
      <ul class="list">
        <li v-for="(item, index) in potltData" :key="index">
          <a
            href="javascript:void(0)"
            class="link_event_menu"
            @click="gotoLink(item)"
          >
            <span
              :style="`background-image:url(/mrm/v1/ignore/attach/image/${item.mobImgAttchFileId}/${item.mobImgFileId})`"
              class="icon"
            />
            <span class="title" v-html="formatMenuText(item.bannNm)" />
          </a>
        </li>
      </ul>
      <!-- // 이벤트 메뉴 리스트 -->

    </div>

    <!-- 이벤트 리스트 펼침 버튼 -->
    <!--
    <button
      ref="eventMenuBtn"
      type="button"
      class="btn_event_menu"
    >주요 카테고리 펼쳐 보기</button>
    -->
    <!-- // 이벤트 리스트 펼침 버튼 -->
  </div>
</template>

<script>
import { isEmpty } from 'lodash'
import commonMixin from '@/mixin/commonMixin'
import MotionEffects from '/src/assets/js/MotionEffects'

export default {
  name: 'Promotion',
  mixins: [commonMixin, MotionEffects],
  props: {
    potltInfo: {
      type: Object,
      default: null
    },
    classes: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      isVisible: false,
      // 아이콘 메뉴 데이터
      eventMenuList: {}
    }
  },
  computed: {
    potltData () {
      return this.potltInfo.potltData || []
    },
    isDesktop () {
      return window.vue.getStore('homeInfo').state.isDeskTopMode
    }
  },
  created () {
    this.isVisible = !isEmpty(this.potltData)
  },
  mounted () {
    // // 포틀릿 데이터 조회
    // this.$http.b2c.portletData(this, { potltCd: this.potltInfo.potltCd, potltNo: this.potltInfo.potltNo, langCd: this.getUserLangCd() } ).then( (result) => {
    //   const data = result.data
    //   if ( data.status === 'OK' ) {
    //     console.log('portletData', data)
    //     this.isVisible = true
    //     this.potltData = data.data
    //   } else {
    //     // 데이터 없음
    //   }
    // })
  },
  methods: {
    gotoLink (item) {
      this.$emit('hideEventMenuPc')
      this.goPotltLink(item)
    },
    removeTag (str) {
      return str.replace(/<br\s*\/?>/gi, '')
    },
    formatMenuText (str) {
      return this.isDesktop ? this.removeTag(str) : str
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/portlet/Promotion.vue